import React, { useEffect, useState } from "react";
import axiosInstance from "../axiosInstance/AxiosInstance";
import { useMessage } from "../MessageProvider/MessageProvider";
import { Modal, Tag, Tooltip } from "antd";
import moment from "moment";
import { Link } from "react-router-dom";
import { IoCheckmarkDoneCircleSharp } from "react-icons/io5";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { IoMdInformationCircleOutline } from "react-icons/io";
import YukXatiStatus from "./YukXatiStatus";

export default function YukXatiListItem({
  el,
  data,
  setData,
  setSelected,
  selected,
}) {
  let [isModalOpen, setIsModalOpen] = useState(false);
  let [loading, setLoading] = useState(false);
  const messageApi = useMessage();
  let [info, setInfo] = useState(null);

  const copyContent = async (text) => {
    try {
      await navigator.clipboard.writeText(text);

      messageApi.open({
        type: "success",
        content: "Copied!",
      });
    } catch (err) {
      messageApi.open({
        type: "success",
        content: "Failed to copy!",
      });
    }
  };

  let getYukXati = async (id) => {
    try {
      setLoading(true);
      console.log(id);

      let { data } = await axiosInstance.get("/api/chiqim/" + id);

      if (data.success) {
        console.log("data");
        console.log(data.data[0]);
        setInfo(data.data[0]);
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Link
      onContextMenu={(e) => {
        e.preventDefault();
        data.map((item) => {
          if (
            item?.id === el?.id &&
            selected.some((item) => item.id === el?.id)
          ) {
            setSelected([...selected.filter((slct) => slct?.id !== item?.id)]);
          }

          if (
            item?.id === el?.id &&
            !selected.some((item) => item.id === el?.id)
          ) {
            setSelected([...selected, el]);
          }
        });
      }}
      to={"/yukxati/" + el?.id}
      className={
        selected.some((item) => item.id === el?.id)
          ? "shrink-0  text-stone-900 text-bold cursor-pointer shadow-sm  border-[1px] border- hover:text-sky-400 hover:scale-[0.9] scale-[0.9] transition duration-[75] ease-in-out hover:text-sky-400 max-w-[900px] w-[100%]  py-2 text-stone-900 text-bold p-1    bg-[#d1fae5] cursor-pointer  border-[1px] border-[#bfbfbf36] hover:text-[#10b981]"
          : el?.confirm
          ? "shrink-0  justify-items-start items-center  relative text-stone-900 text-bold cursor-pointer shadow-sm hover:scale-[0.9]  border-[1px] border-indigo-500 hover:text-sky-400 transition duration-[75] ease-in-out hover:text-sky-400 max-w-[900px] w-[100%]  py-2 text-stone-900 text-bold p-1    bg-[#d1fae5] cursor-pointer  border-[1px] border-[#bfbfbf36] hover:text-[#10b981]"
          : "shrink-0  justify-items-start items-center  relative text-stone-900 text-bold cursor-pointer shadow-sm hover:scale-[0.9]  border-[1px] border-indigo-500 hover:text-sky-400 transition duration-[75] ease-in-out hover:text-sky-400 max-w-[900px] w-[100%]  py-2 text-stone-900 text-bold p-1    bg-[#fff] cursor-pointer  border-[1px] border-[#bfbfbf36] hover:text-[#10b981]"
      }
    >
      <div className="w-[100%] flex flex-row items-center justify-between pb-1">
        <p
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
          className="text-[18px] md:text-[14px] text-[#111827] p-0 m-0  md:col-span-2 hover:text-sky-400"
        >
          {el.id}- {el.name}{" "}
        </p>
        <p className="text-[14px] text-[#6b7280]  p-0 m-0">
          <Tooltip
            sx={{ fontSize: "10px" }}
            className="text-[14px]"
            title={`yaratildi: ${el?.created_at} \n updated: ${el?.updated_at}`}
          >
            {moment(el.date).format("DD.MM.YYYY")}
          </Tooltip>
        </p>
      </div>
      <div className="w-[100%] flex flex-row items-center justify-between pl-2">
        <h2
          className="text-[14px] text-[#6b7280] p-0 m-0"
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {el?.products?.map((val) => {
            return val?.name + " : " + val?.tonna;
          })}
        </h2>
        <p className="m-0 p-0 italic text-[15px] bold">
          <span
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            className="text-[12px]"
          >
            {el?.given_by?.name + "  "}
          </span>
          #{el?.status}{" "}
        </p>{" "}
      </div>
    </Link>
  );
}
